import businessTargetsList from './businessTargetsList';
import businessTargetsEdit from './businessTargetsEdit.js';
import businessTargetsImport from './businessTargetsImport.js';


export default {
    list: businessTargetsList,
    edit: businessTargetsEdit,
    create: businessTargetsImport
}